import Routes from "./routes";
import { StateProvider } from "store/StateProvider";
import { ToastContainer /* toast */ } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";
import { QueryClient, QueryClientProvider } from "react-query";
import ErrorBoundary from "components/ErrorBoundary";
import PageTransitionLoader from "components/PageTransitionLoader";
import PwaInstallPrompt from "components/PwaInstallPrompt";
import SupportFloatingButton from "components/SupportFloatingButton";
import UseDevToolsRedirect from "helpers/useDevTool";
import disableDevtool from "disable-devtool";
import { ThemeProvider, useTheme } from "hooks/useTheme";
const queryClient = new QueryClient();

function AppContent() {
  const { theme } = useTheme();

  return (
    <StateProvider>
      <QueryClientProvider client={queryClient}>
        <Routes />
        <PageTransitionLoader />
        <PwaInstallPrompt />
        <SupportFloatingButton />
        <ToastContainer theme={theme} />
      </QueryClientProvider>
    </StateProvider>
  );
}

function App() {
  // disableDevtool();
  return (
    <ErrorBoundary>
      {/* <UseDevToolsRedirect /> */}
      {/* <TitleBar /> */}
      <ThemeProvider>
        <AppContent />
      </ThemeProvider>
    </ErrorBoundary>
  );
}
export default App;
